export const GET_INBOX = "GET_INBOX";
export const POST_INBOX = "POST_INBOX";
export const SHOW_INBOX = "SHOW_INBOX";
export const UPDATE_INBOX = "UPDATE_INBOX";
export const DELETE_INBOX = "DELETE_INBOX";
export const GET_MEMBER_GROUP = "GET_MEMBER_GROUP";
export const GET_CATEGORY = "GET_CATEGORY";
export const DROPDOWN = "INBOX_DROPDOWN";
